// src/features/modelsSlice.ts
import { createSlice } from '@reduxjs/toolkit';
import { apiKeysApi } from '~/api/api-key-api';

enum ApiKeyType {
  Public = 'public',
  Test = 'test',
}

// Define the ApiKey type
export interface ApiKey {
  id?: string;
  uid?: string;
  org_id?: string;
  application?: string;
  domains?: string[];
  created?: string;
  updated?: string;
  type?: string;
  value?: string;
}

// Define the state interface for api_keys
interface ApiKeysState {
  api_keys: any | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
}

const initialState: ApiKeysState = {
  api_keys: null,
  status: 'idle',
  error: null,
};

const apiKeysSlice = createSlice({
  name: 'api_keys',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(apiKeysApi.endpoints.getApiKeys.matchPending, (state) => {
        state.status = 'loading';
      })
      .addMatcher(apiKeysApi.endpoints.getApiKeys.matchFulfilled, (state, action) => {
        state.status = 'succeeded';
        state.api_keys = action.payload.response;
      })
      .addMatcher(apiKeysApi.endpoints.getApiKeys.matchRejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Failed to fetch api_keys';
      })
      .addMatcher(apiKeysApi.endpoints.updateApiKey.matchPending, (state) => {
        state.status = 'loading';
      })
      .addMatcher(apiKeysApi.endpoints.updateApiKey.matchFulfilled, (state, action) => {
        state.status = 'succeeded';
        const index = state.api_keys.findIndex((o) => o.id === action.payload.id);
        if (index !== -1) {
          state.api_keys[index] = action.payload;
        }
      })
      .addMatcher(apiKeysApi.endpoints.updateApiKey.matchRejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message ?? 'Failed to update organization';
      });
  },
});

export default apiKeysSlice.reducer;
